import React, { useCallback, useState, useEffect } from 'react';
import { Button } from '../../components/Button';
import { useNavigate } from 'react-router-dom';
import config from '../../config';
import { useSelector } from 'react-redux';

import DoubleRangeSlider from '../../components/ui/DoubleRangeSlider';
import { INTEREST } from '../../constants/interests';
import useAxiosPrivate from '../../hooks/useAxiosPrivate';
import { useSubscription } from '../../hooks/useSubscription';
import {
  DEFAULT_FILTERS,
  getActiveFiltersCount,
  loadFiltersFromLocalStorage,
  normalizeFilters,
  resolveMeetFilters,
  saveFiltersToLocalStorage
} from './utils/filters';

const interests = INTEREST;

const options = [
  {
    id: 1,
    title: 'Флирт и свидания',
    description: 'Ходить на свидания и хорошо проводить время',
    emoji: '🔥'
  },
  {
    id: 2,
    title: 'Серьеёзные отношения',
    description: 'Найти вторую половинку и создать счастливые отношения',
    emoji: '💍'
  },
  {
    id: 3,
    title: 'Дружеское общение',
    description: 'Найти друзей и знакомых, общаться и договариватся о встречах',
    emoji: '✌️'
  },
  {
    id: 4,
    title: 'Обовсём и ни о чём',
    description: 'Общаться, делиться мыслями и идями без ограничений',
    emoji: '🥂'
  }
];

function Filters() {
  console.log('[Filters] render');
  const axiosPrivate = useAxiosPrivate();
  const { isActiveSubscription } = useSubscription();

  const [selectedOption, setSelectedOption] = useState(null);
  const [selectedInterests, setSelectedInterests] = useState([]);
  const [resetCounter, setResetCounter] = useState(0);
  const [isSaving, setIsSaving] = useState(false);
  const { telegramId } = useSelector((state) => state.auth);

  const navigate = useNavigate();

  const [cityInput, setCityInput] = useState('');

  const [rangeAge, setRangeAge] = useState({ min: 18, max: 100 });
  const [rangeDist, setRangeDist] = useState({ min: 0, max: 100 });

  useEffect(() => {
    applyFiltersState();
  }, []);

  const applyFiltersState = (filters) => {
    console.log('[Filters] applyFiltersState');

    const normalizedFilters = loadFiltersFromLocalStorage();

    setSelectedOption(normalizedFilters.purpose || null);
    setSelectedInterests(normalizedFilters.interests);
    setRangeAge(normalizedFilters.ageRange);
    setRangeDist(normalizedFilters.distanceRange);
    setCityInput(normalizedFilters.city);
  };

  const addInterest = (optionId) => {
    setSelectedInterests((prev) => {
      const newInterests = prev.includes(optionId) ? prev.filter((id) => id !== optionId) : [...prev, optionId];

      // Сохраняем в localStorage при изменении
      const currentFilters = {
        purpose: selectedOption,
        interests: newInterests,
        ageRange: rangeAge,
        distanceRange: rangeDist,
        city: cityInput
      };
      saveFiltersToLocalStorage(currentFilters);

      return newInterests;
    });
  };

  const handleAgeChange = useCallback(({ min, max }) => {
    console.log('[Filters] handleAgeChange');
    setRangeAge((prev) => {
      if (prev.min !== min || prev.max !== max) {
        const newAge = { min, max };
        return newAge;
      }
      return prev;
    });
  }, []);

  const handleDistChange = useCallback(({ min, max }) => {
    console.log('[Filters] handleDistChange');
    setRangeDist((prev) => {
      if (prev.min !== min || prev.max !== max) {
        const newDist = { min, max };
        return newDist;
      }
      return prev;
    });
  }, []);

  const handleClear = async () => {
    try {
      setIsSaving(true);

      const defaultFilters = DEFAULT_FILTERS;

      // Clear filters on the backend
      await axiosPrivate.put(config.API.USERS.UPDATE_FILTERS, {
        telegramId,
        filters: defaultFilters
      });

      // Clear UI state
      setSelectedInterests([]);
      setSelectedOption(null);
      setRangeAge({ min: 18, max: 80 });
      setRangeDist({ min: 0, max: 100 });
      setCityInput('');
      setResetCounter((prev) => prev + 1);

      // Clear localStorage
      saveFiltersToLocalStorage(defaultFilters);
    } catch (error) {
      console.error('Error clearing filters:', error);
    } finally {
      setIsSaving(false);
    }
  };

  const saveFilters = async () => {
    try {
      setIsSaving(true);
      const filtersToSave = {
        purpose: selectedOption,
        interests: selectedInterests,
        ageRange: rangeAge,
        distanceRange: rangeDist,
        city: isActiveSubscription ? cityInput.trim() : ''
      };

      await axiosPrivate.put(config.API.USERS.UPDATE_FILTERS, {
        telegramId,
        filters: filtersToSave
      });

      // Сохраняем в localStorage после успешного сохранения на сервере
      saveFiltersToLocalStorage(filtersToSave);

      // Перенаправляем с параметром для перезагрузки анкет
      navigate('/meet', { state: { reloadMatches: true } });
    } catch (error) {
      console.error('Error saving filters:', error);
      // При ошибке все равно сохраняем локально
      const filtersToSave = {
        purpose: selectedOption,
        interests: selectedInterests,
        ageRange: rangeAge,
        distanceRange: rangeDist,
        city: isActiveSubscription ? cityInput.trim() : ''
      };
      saveFiltersToLocalStorage(filtersToSave);
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <div className="w-[100%] h-[auto] flex justify-center">
      <div className="h-[auto] flex flex-col justify-start items-start w-full px-4">
        <div className="sticky w-full top-0 left-0 right-0 pt-[26px] pb-4 z-50">
          <div className="w-full flex justify-between items-center">
            <div onClick={() => (window.location.href = '/meet')}>
              <img src="/icons/Button-back.svg" className="w-[44px] h-[44px]" />
            </div>
            <div onClick={handleClear} className="flex items-center gap-2">
              <p className="text-white">Сбросить</p>
              {getActiveFiltersCount() > 0 && <div className="w-2 h-2 bg-[#a1f69e] rounded-full"></div>}
            </div>
          </div>
        </div>

        <div className="flex items-center gap-3 mt-6">
          <h1 className="font-raleway font-semibold text-white text-[26px]">Фильтры</h1>
          {getActiveFiltersCount() > 0 && (
            <div className="bg-[#a1f69e] text-[#022424] rounded-full w-6 h-6 flex items-center justify-center text-sm font-semibold">
              {getActiveFiltersCount()}
            </div>
          )}
        </div>

        <div className="flex flex-row justify-between items-center w-full">
          <h1 className="font-raleway font-semibold mt-[32px] text-white text-[20px]">Возраст:</h1>
          <h1 className="font-raleway font-semibold mt-[32px] text-white text-[20px]">
            {rangeAge.min}-{rangeAge.max} лет
          </h1>
        </div>

        <div className="relative w-full">
          <DoubleRangeSlider
            min={18}
            max={80}
            value={rangeAge}
            onChange={handleAgeChange}
            resetTrigger={resetCounter}
          />
        </div>

        <div className="flex flex-row justify-between items-center w-full">
          <h1 className="font-raleway font-semibold mt-[32px] text-white text-[20px]">Расстояние:</h1>
          <h1 className="font-raleway font-semibold mt-[32px] text-white text-[20px]">
            {rangeDist.min}-{rangeDist.max}
            {rangeDist.max === 100 ? '+' : ''}км
          </h1>
        </div>

        <div className="relative w-full">
          <DoubleRangeSlider
            min={0}
            max={100}
            value={rangeDist}
            onChange={handleDistChange}
            resetTrigger={resetCounter}
          />
        </div>

        <div className="flex flex-row justify-between items-center w-full">
          <h1 className="font-raleway font-semibold mt-[32px] text-white text-[20px]">Населенный пункт:</h1>
          {!isActiveSubscription && <img src="/icons/premium.svg" className="mt-[32px] w-[121px]" />}
        </div>

        <div className="relative w-full">
          <input
            type="text"
            placeholder="Введите название"
            value={cityInput}
            onChange={(e) => {
              if (isActiveSubscription) {
                setCityInput(e.target.value);
              }
            }}
            disabled={!isActiveSubscription}
            className={`w-full h-[64px] rounded-[8px] bg-[#022424] mt-4 pl-4 border border-[#233636] text-white outline-none focus:border-[#a1f69e] ${
              !isActiveSubscription ? 'opacity-40 cursor-not-allowed' : ''
            }`}
          />
          {!isActiveSubscription && (
            <div className="absolute inset-0 cursor-pointer" onClick={() => navigate('/premium')} />
          )}
        </div>

        <div className="flex flex-row justify-between items-center w-full">
          <h1 className="font-raleway font-semibold mt-[32px] text-white text-[20px]">Статус:</h1>
          {!isActiveSubscription && <img src="/icons/premium.svg" className="mt-[32px] w-[121px]" />}
        </div>

        <div
          className={`grid gric-cols-1 justify-start flex-wrap items-center gap-[16px] mt-[16px] ${
            !isActiveSubscription ? 'opacity-40' : ''
          } relative`}
        >
          {options.map((option, index) => (
            <div
              key={index}
              onClick={() => {
                if (isActiveSubscription) {
                  setSelectedOption(option.id);
                  // Сохраняем в localStorage при изменении
                  const currentFilters = {
                    purpose: option.id,
                    interests: selectedInterests,
                    ageRange: rangeAge,
                    distanceRange: rangeDist,
                    city: cityInput
                  };
                  saveFiltersToLocalStorage(currentFilters);
                }
              }}
              className={`w-[auto] p-3 h-[48px] rounded-[400px] flex items-center text-[#FFFFFF] transition-all 
                        ${isActiveSubscription ? 'cursor-pointer' : 'cursor-not-allowed'}
                        ${
                          selectedOption === option.id && isActiveSubscription
                            ? 'bg-[#043939] border-[1.5px] border-[#a1f69e]'
                            : 'bg-[#022424] border-[1px] border-[#233636]'
                        }`}
            >
              <span className="flex items-center justify-center text-[24px] w-[30px] ml-1 mr-1.5 text-center">
                {option.emoji}
              </span>
              <span className={`w-[auto] text-[18px] font-normal`}>{option.title}</span>
            </div>
          ))}
          {!isActiveSubscription && (
            <div className="absolute inset-0 cursor-pointer" onClick={() => navigate('/premium')} />
          )}
        </div>

        <h1 className="font-raleway font-semibold mt-[32px] text-white text-[20px]">Интересы:</h1>
        <div className="flex flex-wrap  gap-[16px] mt-[16px] pb-[200px]">
          {interests.map((option, index) => (
            <div
              key={index}
              onClick={() => addInterest(option.id)}
              className={`w-[auto] p-3 h-[48px] rounded-[400px] flex justify-center items-center text-[18px] font-light text-white gap-[8px] cursor-pointer transition-all 
            ${
              selectedInterests.includes(option.id)
                ? 'bg-[#043939] border-[1.5px] border-[#a1f69e]'
                : 'bg-[#022424] border-[1px] border-[#233636]'
            }`}
            >
              <span>{option.id}</span>
            </div>
          ))}
        </div>

        <div className="fixed z-10 bottom-4 left-4 right-4">
          <Button className="w-full" onClick={saveFilters} disabled={isSaving} loading={isSaving}>
            Применить
          </Button>
        </div>
      </div>
    </div>
  );
}

export default Filters;
